<p>
	<a [routerLink]="cmsResult.urls['abs-submit-part-a']" class="btn btn--gold">Continue to Part A (Budget Info)</a>
</p>
<div [innerHtml]="cmsResult.instructions"></div>
<p>
	<a [routerLink]="cmsResult.urls['abs-submit-part-a']" class="btn btn--gold">Continue to Part A (Budget Info)</a>
</p>